import { useCallback, useEffect, useState } from "react";

import { getMyDocuments } from "../servics/accountDocumentsApi";

/**
 * Dossier documentaire du compte connecté ; `null` sans session ou si le service ne répond
 * pas (compte sans préinscription AGRO, service indisponible) : rien n'est alors affiché.
 * `refreshKey` relance la lecture (ex. changement de page).
 */
const useMyDocuments = (token, refreshKey) => {
    const [state, setState] = useState({ loading: !!token, documents: null, error: null });

    const load = useCallback(() => {
        if (!token) {
            setState({ loading: false, documents: null, error: null });
            return () => {};
        }
        let cancelled = false;
        setState((previous) => ({ ...previous, loading: true }));
        getMyDocuments()
            .then((documents) => {
                if (!cancelled) setState({ loading: false, documents, error: null });
            })
            .catch((error) => {
                if (!cancelled) setState({ loading: false, documents: null, error });
            });
        return () => {
            cancelled = true;
        };
    }, [token]);

    useEffect(() => load(), [load, refreshKey]);

    return { ...state, reload: load, setDocuments: (documents) => setState({ loading: false, documents, error: null }) };
};

export default useMyDocuments;
